import Vue from "vue";
import Vuex from "vuex";
import enums from "./modules/enums";
import routePlanning from "./modules/route-planning";
import customsEntryRegistration from "./modules/customs-entry-registration";

import shippings from "../views/shippings/shippings.js";
import shippingDrafts from "../views/shippings/shipping-drafts.js";
import shipmentRequests from "../views/shipment-requests/shipment-requests.js";
import shipmentRequestDrafts from "../views/shipment-requests/shipment-request-drafts.js";
import goodsDetails from "../views/goods-details/goods-details.js";
import routes from "../views/routes/routes.js";
import route from "../views/routes/route.js";
import customsEntryRegistrations from "../views/customs-entry-registrations/customs-entry-registrations.js";
import activityTypes from "../views/activity-types/activity-types.js";
import addresses from "../views/addresses/addresses.js";
import articles from "../views/articles/articles.js";
import carriers from "../views/carriers/carriers.js";
import cities from "../views/cities/cities.js";
import clients from "../views/clients/clients.js";
import contactPersons from "../views/contact-persons/contact-persons.js";
import countries from "../views/countries/countries.js";
import currencies from "../views/currencies/currencies.js";
import drivers from "../views/drivers/drivers.js";
import employees from "../views/employees/employees.js";
import factories from "../views/factories/factories.js";
import manufacturers from "../views/manufacturers/manufacturers.js";
import forwarders from "../views/forwarders/forwarders.js";
import nomenclatures from "../views/nomenclatures/nomenclatures.js";
import offices from "../views/offices/offices.js";
import positions from "../views/positions/positions.js";
import productCategories from "../views/product-categories/product-categories.js";
import regions from "../views/regions/regions.js";
import trademarkModels from "../views/trademark-models/trademark-models.js";
import trademarks from "../views/trademarks/trademarks.js";
import units from "../views/units/units.js";
import users from "../views/users/users.js";
import vehicles from "../views/vehicles/vehicles.js";
import warehouses from "../views/warehouses/warehouses.js";
import rollingStocks from "../views/rolling-stocks/rolling-stocks.js";
import rollingStockTypes from "../views/rolling-stock-types/rolling-stock-types.js";
import clientDashboardShippings from "../views/shippings/client-dashboard-shippings.js";
import clientDashboardRequests from "../views/shipment-requests/client-dashboard-requests.js";
import districts from "../views/districts/districts.js";
import shipping from "./modules/shipping.js";
import releaseOrders from "../views/release-orders/release-orders.js";
import goodsTypes from "../views/goods-types/goods-types.js";
import tariffs from "../views/tariffs/tariffs.js";
import oldVersionWarehouseDetails from "./modules/old-version-warehouse-details.js";
import warehouseDetails from "./modules/warehouse-details.js";
import locations from "../views/locations/locations.js";
import courierServices from "../views/courier-service/courier-service.js";
import packageTypes from "../views/package-types/package-types.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    enums,
    routePlanning,
    shippings,
    shippingDrafts,
    shipmentRequests,
    shipmentRequestDrafts,
    goodsDetails,
    routes,
    route,
    customsEntryRegistrations,
    activityTypes,
    addresses,
    articles,
    carriers,
    cities,
    clients,
    contactPersons,
    countries,
    currencies,
    drivers,
    employees,
    factories,
    manufacturers,
    forwarders,
    nomenclatures,
    offices,
    positions,
    productCategories,
    regions,
    trademarkModels,
    trademarks,
    units,
    users,
    vehicles,
    warehouses,
    rollingStocks,
    rollingStockTypes,
    clientDashboardRequests,
    clientDashboardShippings,
    districts,
    customsEntryRegistration,
    shipping,
    releaseOrders,
    goodsTypes,
    tariffs,
    oldVersionWarehouseDetails,
    warehouseDetails,
    locations,
    courierServices,
    packageTypes,
  },
});
